import React from 'react';

import { DeliveriesProps } from './Deliveries.props';

import DeliveriesView from './Deliveries.view';

const DeliveriesContainer = (props: DeliveriesProps) => {
  return <DeliveriesView />;
};

export default DeliveriesContainer;
